import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getMyPasswordPolicyRequest = {};
var _getMyPasswordPolicyResponse = {};
var _getPasswordPolicyByForgotPasswordEmailTokenRequest = {};
var _getPasswordPolicyByForgotPasswordEmailTokenResponse = {};
var _updateMyPasswordPolicyRequest = {};
var _updateMyPasswordPolicyResponse = {};
var _updateMyPasswordRequest = {};
var _updateMyPasswordResponse = {};
var _validateMyPasswordPolicyUpdateRequest = {};
var _validateMyPasswordPolicyUpdateResponse = {};
var _validateMyPasswordRequest = {};
var _validateMyPasswordResponse = {};
function resolveWixIamPasswordV1PasswordServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/password',
                destPath: '',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/password',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Gets Password Policy for the logged-in User */
export function getMyPasswordPolicy(payload) {
    var _a = serializer(_getMyPasswordPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyPasswordPolicyResponse, {}).fromJSON;
    function __getMyPasswordPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'GET',
            methodFqn: 'wix.iam.password.v1.PasswordService.GetMyPasswordPolicy',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/password-policies/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyPasswordPolicy.fromReq = fromReq;
    __getMyPasswordPolicy.__isAmbassador = true;
    return __getMyPasswordPolicy;
}
/**
 * Validates if Password Policy can be updated without a password. Possible options:
 * - ValidateMyPasswordPolicyUpdate(password_policy)
 */
export function validateMyPasswordPolicyUpdate(payload) {
    var _a = serializer(_validateMyPasswordPolicyUpdateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateMyPasswordPolicyUpdateResponse, {}).fromJSON;
    function __validateMyPasswordPolicyUpdate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'POST',
            methodFqn: 'wix.iam.password.v1.PasswordService.ValidateMyPasswordPolicyUpdate',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/password-policies/my/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateMyPasswordPolicyUpdate.fromReq = fromReq;
    __validateMyPasswordPolicyUpdate.__isAmbassador = true;
    return __validateMyPasswordPolicyUpdate;
}
/**
 * Updates Password Policy. Possible options:
 * - UpdateMyPasswordPolicy(password_policy)
 * - UpdateMyPasswordPolicy(password_policy, current_password)
 */
export function updateMyPasswordPolicy(payload) {
    var _a = serializer(_updateMyPasswordPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMyPasswordPolicyResponse, {}).fromJSON;
    function __updateMyPasswordPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'PUT',
            methodFqn: 'wix.iam.password.v1.PasswordService.UpdateMyPasswordPolicy',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/password-policies/my',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMyPasswordPolicy.fromReq = fromReq;
    __updateMyPasswordPolicy.__isAmbassador = true;
    return __updateMyPasswordPolicy;
}
/**
 * Validates if Password is valid, taking into account existing Password Policy and given
 * - ValidateMyPassword(password)
 * - ValidateMyPassword(password, password_policy)
 */
export function validateMyPassword(payload) {
    var _a = serializer(_validateMyPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateMyPasswordResponse, {}).fromJSON;
    function __validateMyPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'POST',
            methodFqn: 'wix.iam.password.v1.PasswordService.ValidateMyPassword',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/passwords/my/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateMyPassword.fromReq = fromReq;
    __validateMyPassword.__isAmbassador = true;
    return __validateMyPassword;
}
/**
 * Updates Password with/without Password Policy. Possible options:
 * - UpdateMyPassword(current_password, new_password)
 * - UpdateMyPassword(current_password, new_password, password_policy)
 * Future options:
 * - UpdateMyPassword(new_password, password_policy)
 * - UpdateMyPassword(new_password)
 */
export function updateMyPassword(payload) {
    var _a = serializer(_updateMyPasswordRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMyPasswordResponse, {}).fromJSON;
    function __updateMyPassword(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'PUT',
            methodFqn: 'wix.iam.password.v1.PasswordService.UpdateMyPassword',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/password/my',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMyPassword.fromReq = fromReq;
    __updateMyPassword.__isAmbassador = true;
    return __updateMyPassword;
}
export function getPasswordPolicyByForgotPasswordEmailToken(payload) {
    var _a = serializer(_getPasswordPolicyByForgotPasswordEmailTokenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPasswordPolicyByForgotPasswordEmailTokenResponse, {}).fromJSON;
    function __getPasswordPolicyByForgotPasswordEmailToken(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.password.v1.password',
            method: 'GET',
            methodFqn: 'wix.iam.password.v1.PasswordService.GetPasswordPolicyByForgotPasswordEmailToken',
            url: resolveWixIamPasswordV1PasswordServiceUrl({
                protoPath: '/v1/password-policies/token',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPasswordPolicyByForgotPasswordEmailToken.fromReq = fromReq;
    __getPasswordPolicyByForgotPasswordEmailToken.__isAmbassador = true;
    return __getPasswordPolicyByForgotPasswordEmailToken;
}
//# sourceMappingURL=http.impl.js.map